import * as angular from 'angular';
import * as moment from 'moment';
import * as _ from 'lodash';
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { apsEnums } from "../../shared/dto/aps.enums";
import DateUtilityService from "../../services/utility/dateutility.service";
import CheckListInstancesServiceName, { CheckListInstancesService } from "../../services/checkLists/checkListInstances.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";
import { StateParams } from "../../common";
import { apsCommands } from "../../shared/dto/aps.commands";
import template from './checkListReportDetails.tpl.html';
let requires = [CheckListInstancesServiceName, NotifyServiceName, LoaderServiceName, AuthDataServiceName];

interface CheckListReportDetailsController {
  checkListInstance: apsViewModels.CheckListInstanceReportItem;
  detail: apsViewModels.CheckListInstanceReportDetail;
  status: string;

  formatTime(time: Date | moment.Moment): string;

  formatCheckStatus(status: apsEnums.CheckStatus): string;
  getResult(instance: apsViewModels.CheckInstanceReportItem): string;
}

export interface CheckListReportDetailsControllerParams {
  checkListInstance: apsViewModels.CheckListInstanceReportItem;
  detail: apsViewModels.CheckListInstanceReportDetail;
}

export function openCheckListReportDetails(
  params: CheckListReportDetailsControllerParams,
  $modal: mm.foundation.modal): void {
  $modal.open({
    template: template,
    controller: 'CheckListReportDetailsCtrl as vm',
    resolve: {
      params: () => params
    }
  });
}

class CheckListReportDetailsCtrl implements CheckListReportDetailsController {
  $modalInstance: mm.foundation.modalInstance;

  private checkListInstancesService: CheckListInstancesService;
  private notifyService: NotifyService;
  private loaderService: LoaderService;
  checkListInstance: apsViewModels.CheckListInstanceReportItem;
  detail: apsViewModels.CheckListInstanceReportDetail;
  status: string;
  private authDataService: AuthDataService;
  private $modal: mm.foundation.modal;
  private scheduledOn: string;
  private userId: string;
  private isReport: boolean;
  constructor(
    params: CheckListReportDetailsControllerParams,
    authDataService: AuthDataService,
    checkListInstancesService: CheckListInstancesService,
    notifyService: NotifyService,
    loaderService: LoaderService,
    $modal: mm.foundation.modal,
    $stateParams: StateParams,
    $modalInstance: mm.foundation.modalInstance) {
    this.checkListInstancesService = checkListInstancesService;
    this.notifyService = notifyService;
    this.loaderService = loaderService;
    this.userId = $stateParams.userId;
    this.checkListInstance = params.checkListInstance;
    this.scheduledOn = moment(params.checkListInstance.scheduledOn).format("YYYY-MM-DDTHH:mm:ss");
    this.isReport = false;
    if (this.checkListInstance.checkListId === "df670000-ff45-0003-5041-08d756ef6832") {
      this.isReport = true;
    }
    this.detail = params.detail;
    this.$modalInstance = $modalInstance;
    this.$modal = $modal;
    this.authDataService = authDataService;
    this.status = _.startCase(apsEnums.CheckListStatus[params.checkListInstance.status]);
  }

  formatTime(time: Date | moment.Moment): string {
    return DateUtilityService.formatTime(time, this.checkListInstance.plantTimeZoneId);
  }

  formatCheckStatus(status: apsEnums.CheckStatus): string {
    return _.startCase(apsEnums.CheckStatus[status]);
  }

  close(): void {
    this.$modalInstance.close();
  }

  hasAdditionalData(additionalData: string | null): boolean {
    if (additionalData === null
       || additionalData.length === 0
       || additionalData === '{}') {
      return false;
    }
    return true;
  }

  formatAdditionalData(additionalData: string | null): string {
    if (!this.hasAdditionalData(additionalData)) {
        return '';
    }

    try {
      let json = JSON.parse(additionalData);
      let selected = Object.keys(json)
        .filter(key => json[key]);
      return selected.join(', ');
    }
    catch {
      return '';
    }
  }

  getResult(instance: apsViewModels.CheckInstanceReportItem): string {
    if (!instance || !instance.status || instance.status === apsEnums.CheckStatus.NotDone) {
      return '';
    }

    if ((instance.result || '').length === 0) {
      return 'N/A';
    }

    if ((<any>instance.result) instanceof Date) {
      return this.formatTime(<Date>(<any>instance.result));
    }

    return instance.result;
  }

  canSignOff(signOff: apsViewModels.CheckListInstanceReportSignOffItem): boolean {
    if (this.checkListInstance.isArchived
      || this.checkListInstance.status < apsEnums.CheckListStatus.Complete) {
      return false;
    }

    var selectedRoleLocation = this.authDataService.getSelectedRoleLocation();
    return selectedRoleLocation.role.roleId === signOff.roleId;
  }

  signOff(signOff: apsViewModels.CheckListInstanceReportSignOffItem, scheduledOn: Date, defectId: string): void {
    if (!this.canSignOff(signOff)) {
      return;
    }

    var command: apsCommands.SignOffCheckListInstance = {
      notificationId: null,
      checkListInstanceId: signOff.checkListInstanceId,
      checkListSignOffId: signOff.checkListSignOffId,
      plantLocationId: signOff.plantLocationId,
      scheduledOn: scheduledOn,
      defectId: defectId
    };
    this.loaderService.loadingPromise(
      this.checkListInstancesService.signOff(command)
        .then(() => {
          this.notifyService.success('Sign Off', 'Successful');
          signOff.signedOffByFullName = this.authDataService.getUserData().fullName;
          signOff.signedOffOn = new Date();
        }, this.notifyService.handleApiErrors)
    );
  }

  print(): void {
    var reportHtml = $('#reportWrapper').html();

    var popup = window.open('', 'my div', 'height=800,width=600');
    popup.document.write('<html><head><title>Checklist Report Details</title>');
    popup.document.write('<style>');
    popup.document.write('body, th, td { font-family: arial; font-size: 70% }');
    popup.document.write('.history-t { width: 100% }');
    popup.document.write('.dialog-footer { display: none }');
    popup.document.write('</style>');
    popup.document.write('</head>');
    popup.document.write('<body>');
    popup.document.write(reportHtml);
    popup.document.write('</body>');
    popup.document.write('</html>');
    popup.document.close();
    popup.focus();
    popup.print();
    popup.close();
  }
}

export default angular.module('aps.controller.checkListReportDetails', requires)
  .controller('CheckListReportDetailsCtrl', CheckListReportDetailsCtrl)
  .name;
  


// WEBPACK FOOTER //
// ./src/app/controllers/checkLists/checkListReportDetails.controller.ts